import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ImageEnum } from '../../utils/image.enum';

@Component({
  selector: 'app-popup-layout',
  imports: [],
  templateUrl: './popup-layout.html',
  styleUrl: './popup-layout.css',
})
export class PopupLayoutComponent {
  @Input() showTopBand = true;

  @Output() backdropClick = new EventEmitter<void>();

  protected readonly imageEnum = ImageEnum;

  protected onBackdropClick(): void {
    this.backdropClick.emit();
  }
}
